import { DocsTextItem } from '../types';
import { ROUTES } from './routes';

export const LANDING_PAGE_GUIDE_TITLE = 'DX Portal Landing Page Guide';

export const LANDING_PAGE_GUIDE_INTRO =
  'Welcome to the DX Portal! This guide will help you navigate the portal, understand its capabilities, and manage your experience.';

export const LANDING_PAGE_GUIDE_WHAT_IS_TEXT =
  'The DX Portal is your central hub for accessing and managing DLR digital services. It provides:';

export const LANDING_PAGE_GUIDE_WHAT_IS_ITEMS: string[] = [
  'A catalog of available APIs and services',
  'Documentation and resources for developers',
  'User and team management',
  'Usage analytics and monitoring',
  'Support and community resources',
];

export const LANDING_PAGE_GUIDE_GETTING_STARTED_INTRO =
  "To get started with the DX Portal, you'll need to:";

export const LANDING_PAGE_GUIDE_STEP_ROUTES: Record<
  string,
  string | undefined
> = {
  'Register an account': ROUTES.registration,
  environments: ROUTES.environments,
};

export const LANDING_PAGE_GUIDE_GETTING_STARTED_STEPS = [
  {
    textPrefix: '',
    highlightedText: 'Register an account',
    textSuffix: '',
  },
  {
    textPrefix: 'Learn about the different ',
    highlightedText: 'environments',
    textSuffix: ' available for testing and production',
  },
];

export const LANDING_PAGE_GUIDE_KEY_FEATURES: DocsTextItem[] = [
  {
    title: 'User Management',
    description:
      'Manage your team members, assign roles, and control access to different APIs and services.',
  },
  {
    title: 'Support',
    description:
      'Access our support resources, submit tickets, and get help from our expert team.',
  },
];

export const LANDING_PAGE_GUIDE_KEY_FEATURE_ROUTES: Record<
  string,
  string | undefined
> = {
  'User Management': '/user-management/users',
  Support: '/contact-us',
};

export const LANDING_PAGE_GUIDE_NEXT_STEPS_INTRO =
  'Now that you understand the basics of the DX Portal:';

export const LANDING_PAGE_GUIDE_NEXT_STEP_ROUTES: Record<
  string,
  string | undefined
> = {
  'Getting Started': ROUTES.gettingStarted,
  'Release Notes': ROUTES.releaseNotes,
};

export const LANDING_PAGE_GUIDE_NEXT_STEPS = [
  {
    textPrefix: 'Visit the ',
    highlightedText: 'Getting Started',
    textSuffix: ' guide for step-by-step instructions',
  },
  {
    textPrefix: 'Check out the ',
    highlightedText: 'Release Notes',
    textSuffix: ' for the latest updates',
  },
];

export const LANDING_PAGE_GUIDE_HELP = {
  title: 'Need Help?',
  text: 'If you have questions or need assistance navigating the portal, our support team is here to help. Contact us through the Support section or check our Troubleshooting guide for common issues.',
};
